import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { observer } from 'mobx-react';
import { notificationStore } from '../store/Notification';

const BASE_HIDE_DURATION_MS = 5000;
const EXTRA_LINE_HIDE_DURATION_MS = 2000;

const Notification = observer(() => {
  const detail = notificationStore.detail;

  const formattedMessage =
    typeof detail === 'string'
      ? [detail]
      : detail && typeof detail === 'object'
        ? Object.values(detail)
        : [];

  const messageLineCount = String(notificationStore.message ?? '').split(
    '\n'
  ).length;
  const autoHideDuration =
    BASE_HIDE_DURATION_MS +
    (messageLineCount - 1) * EXTRA_LINE_HIDE_DURATION_MS;

  return (
    <Snackbar
      open={notificationStore.open}
      autoHideDuration={autoHideDuration}
      onClose={() => notificationStore.closeMessage()}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity={notificationStore.severity}
        onClose={() => notificationStore.closeMessage()}
      >
        <div style={{ whiteSpace: 'pre-line' }}>
          {notificationStore.message}
        </div>
        {formattedMessage.length > 0 ? (
          <>
            <div style={{ marginTop: '15px' }}>
              {formattedMessage.map((msg: any, index) => (
                <div key={index}>{msg}</div>
              ))}
            </div>
          </>
        ) : null}
      </Alert>
    </Snackbar>
  );
});

export default Notification;
